import { APPLICATIONS, ScholarshipServicePath } from "utils/constants";
import ListScholarshipApplications from "./List";
import ShowScholarshipApplications from "./Show";
import permissions from "app/permissions";
import CampaignIcon from "@mui/icons-material/Campaign";

export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  name: ScholarshipServicePath + APPLICATIONS,
  title: "Кандидатури стипендии",
  list: <ListScholarshipApplications />,
  show: <ShowScholarshipApplications />,
  permission: permissions.canPreviewScholarshipApplications,
};
